import React from "react";
import { Button, DropDown } from "@src/components/atoms";
import { SignolUtils } from "@src/utils";

const alignmentOptions = [
  {
    text: "Left Align",
    value: "left",
  },
  {
    text: "Center Align",
    value: "center",
  },
  {
    text: "Right Align",
    value: "right",
  },
];

const widthOptions = [
  {
    text: "full",
    value: "4",
  },
  {
    text: "1/2",
    value: "2",
  },
  {
    text: "1/3",
    value: "1.3",
  },
  {
    text: "2/3",
    value: "2.6",
  },
  {
    text: "1/4",
    value: "1",
  },
  {
    text: "3/4",
    value: "3",
  },
];

const columnContentOptions = [
  {
    text: "Data Card",
    value: "data",
  },
  {
    text: "Behaviour Card",
    value: "behaviour_data",
  },
  {
    text: "Behaviour Graph",
    value: "graph",
  },
  {
    text: "Generic Graph",
    value: "generic_graph",
  },
];

export const ColumnEditor = (props) => {
  const {
    behaviourCode,
    data,
    width,
    align,
    removeCol,
    sectionIndex,
    rowIndex,
    colIndex,
    changeWidth,
    changeAlign,
    availableColValues,
    dataOptions,
    behaviourOptions,
    changeGraph,
    changeBehaviour,
    duplicateGraphs,
    contentType,
    changeContentType,
  } = props;
  const availableColOptions = widthOptions.filter(
    (option) =>
      option.value === width ||
      Number(option.value) <= availableColValues + Number(width),
  );
  const graphOptions = dataOptions.filter((option) => {
    return option.value === null || option.value.includes("/figures/");
  });
  const cardOptions = dataOptions.filter((option) => {
    let isBehaviour = false;
    for (let b = 0; b < behaviourOptions.length; b++) {
      if (
        option.value &&
        option.value.includes(`/${behaviourOptions[b].value.toLowerCase()}/`)
      ) {
        isBehaviour = true;
      }
    }
    return (
      !isBehaviour && (option.value === null || option.value.includes("/data/"))
    );
  });
  const availableGraphOptions = graphOptions.filter((option) => {
    return (
      option.value === null ||
      option.value.includes(behaviourCode.toLowerCase())
    );
  });

  const availableGenericGraphOptions = graphOptions.filter((option) => {
    let isBehaviour = false;
    for (let b = 0; b < behaviourOptions.length; b++) {
      if (
        option.value &&
        option.value.includes(`/${behaviourOptions[b].value.toLowerCase()}`)
      ) {
        isBehaviour = true;
      }
    }
    return (
      !isBehaviour &&
      (option.value === null || option.value.includes("/figures/"))
    );
  });

  const availableBehaviourCardOptions = dataOptions.filter((option) => {
    return (
      option.value === null ||
      (option.value.includes(behaviourCode.toLowerCase()) &&
        option.value.includes("/data/"))
    );
  });

  const handleRemoveCol = () => {
    removeCol(sectionIndex, rowIndex, colIndex);
  };

  const handleChangeWidth = (newWidthValue) => {
    changeWidth(sectionIndex, rowIndex, colIndex, newWidthValue);
  };

  const handleChangeAlign = (newAlignValue) => {
    changeAlign(sectionIndex, rowIndex, colIndex, newAlignValue);
  };

  const handleChangeGraph = (newGraphValue) => {
    changeGraph(sectionIndex, rowIndex, colIndex, newGraphValue);
  };

  const handleChangeBehaviour = (newBehaviourValue) => {
    if (newBehaviourValue === "all") {
      const allBehaviours = [];
      for (let o = 0; o < dataOptions.length; o++) {
        if (
          dataOptions[o].value !== null &&
          dataOptions[o].value.includes("/data/") &&
          dataOptions[o].value.includes("/behaviour_card")
        ) {
          allBehaviours.push(dataOptions[o].value);
        }
      }
      changeWidth(sectionIndex, rowIndex, colIndex, 4);
      changeGraph(sectionIndex, rowIndex, colIndex, allBehaviours);
    }
    changeBehaviour(sectionIndex, rowIndex, colIndex, newBehaviourValue);
  };

  const handelChangeContentType = (newContentValue) => {
    changeContentType(sectionIndex, rowIndex, colIndex, newContentValue);
  };

  return (
    <div className="flex flex-col p-3 w-1/5">
      <span>Content Type:</span>
      <DropDown
        minWidth={false}
        fullWidth={true}
        value={contentType}
        options={columnContentOptions}
        onChange={handelChangeContentType}
      />
      {contentType === "graph" && (
        <>
          <span>Behaviour:</span>
          <DropDown
            minWidth={false}
            fullWidth={true}
            value={behaviourCode}
            options={behaviourOptions}
            onChange={handleChangeBehaviour}
            enableSearch={true}
          />
          <span className={`mt-1${!data ? " text-red-400" : ""}`}>
            Graph JSON:
          </span>
          <DropDown
            minWidth={false}
            fullWidth={true}
            value={SignolUtils.normalizeBehiveKey(data)}
            options={availableGraphOptions}
            onChange={handleChangeGraph}
            enableSearch={true}
            errorState={!data}
          />
        </>
      )}
      {contentType === "data" && (
        <>
          <span className={`mt-1${!data ? " text-red-400" : ""}`}>
            Data JSON:
          </span>
          <DropDown
            minWidth={false}
            fullWidth={true}
            value={SignolUtils.normalizeBehiveKey(data)}
            options={cardOptions}
            onChange={handleChangeGraph}
            enableSearch={true}
            errorState={!data}
          />
        </>
      )}
      {contentType === "generic_graph" && (
        <>
          <span className={`mt-1${!data ? " text-red-400" : ""}`}>
            Graph JSON:
          </span>
          <DropDown
            minWidth={false}
            fullWidth={true}
            value={SignolUtils.normalizeBehiveKey(data)}
            options={availableGenericGraphOptions}
            onChange={handleChangeGraph}
            enableSearch={true}
            errorState={!data}
          />
        </>
      )}
      {contentType === "behaviour_data" && (
        <>
          <span>Behaviour:</span>
          <DropDown
            minWidth={false}
            fullWidth={true}
            value={behaviourCode}
            options={
              availableColOptions.filter((option) => option.value === "4")
                .length === 1
                ? [{ text: "All", value: "all" }, ...behaviourOptions]
                : behaviourOptions
            }
            onChange={handleChangeBehaviour}
            enableSearch={true}
          />
          {behaviourCode !== "all" && (
            <>
              <span className="mt-1">Data JSON:</span>
              <DropDown
                minWidth={false}
                fullWidth={true}
                value={SignolUtils.normalizeBehiveKey(data)}
                options={availableBehaviourCardOptions}
                onChange={handleChangeGraph}
                enableSearch={true}
                errorState={!data}
              />
            </>
          )}
        </>
      )}
      {duplicateGraphs.includes(
        Array.isArray(data) ? data : SignolUtils.normalizeBehiveKey(data),
      ) && <span>This JSON is used more than once in this layout</span>}
      <span className="mt-1">width:</span>
      <DropDown
        minWidth={false}
        fullWidth={true}
        value={width}
        options={availableColOptions}
        onChange={handleChangeWidth}
      />
      {availableColValues >= 0.1 && (
        <>
          <span className="mt-1">Alignment:</span>
          <DropDown
            minWidth={false}
            fullWidth={true}
            value={align}
            options={alignmentOptions}
            onChange={handleChangeAlign}
          />
        </>
      )}
      <Button color="red" onClick={handleRemoveCol}>
        Remove Column
      </Button>
    </div>
  );
};
